
import { useIsAdminLoading } from '../../hooks/isAdmin';
import { useIsCenterManagerLoading } from '../../hooks/isCenterManager';

interface PersonaSwitcherProps {
    adminView: JSX.Element;
    centerManagerView?: JSX.Element;
    teacherView: JSX.Element;
}

const PersonaSwitcher = ({ adminView, teacherView, centerManagerView }: PersonaSwitcherProps ) => {
  const [isAdmin, loadingAdmin] = useIsAdminLoading();
  const [isCenterManager, loadingCM] = useIsCenterManagerLoading();

  if (loadingAdmin || loadingCM) {
    return null;
  }

  if (isAdmin) {
    return adminView;
  }

  if (isCenterManager) {
    return centerManagerView || teacherView;
  }

  return teacherView
};

export { PersonaSwitcher };
